import { getApiErrorMessage } from "@timenotes/shared/src/services/api-client"
import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { useDeleteCommentMutation } from "@timenotes/shared/src/services/comments/queries/use-delete-comment-mutation"
import { useArchiveTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-archive-task-mutation"
import { useDeleteTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-delete-task-mutation"
import { useRestoreTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-restore-task-mutation"
import { message, Modal, Tooltip } from "antd"
import { ArchiveSvg, DeleteSvg, MoreSvg } from "assets/svg/icon"
import GenericButtonsList, { TGenericButton } from "components/generic-buttons-list/generic-buttons-list"

interface Props {
  projectId: string
  taskId: string
  commentId: string
}

export const TaskCommentOptions = (props: Props) => {
  const {
    projectId,
    taskId,
    commentId,
  } = props

  const deleteCommentMutation = useDeleteCommentMutation({
    projectId: projectId
  })
  const onDelete = async () => {
    try {
      await deleteCommentMutation.mutateAsync({
        taskId: taskId,
        commentId: commentId,
      }, {
        onSuccess: () => {
          message.success('Task comment deleted!')
        }
      })
    } catch (errors) {
      message.error(getApiErrorMessage({ errors: errors } as any, 'base'))
    }
  }
  const buttons: TGenericButton[] = [
    {
      title: "",
      icon: MoreSvg,
      type: "text",
      options: [
        {
          title: "Delete comment",
          Icon: DeleteSvg,
          callback: () => {
            Modal.confirm({
              onOk: onDelete,
              width: 500,
              okText: "Delete",
              okType: "primary",
              style: { whiteSpace: "pre-line" },
              okButtonProps: { danger: true },
              title: (
                <span style={{ whiteSpace: "nowrap" }}>
                  Are you sure you want to delete this comment?
                </span>
              ),
              content:
                "",
            })
          },
        },
      ],
    },
  ]


  return (
    <Tooltip title="More Actions">
      <GenericButtonsList buttons={buttons} />
    </Tooltip>
  )

}